import { Base } from '@studiometa/js-toolkit';

/**
 * Aperçu de carte et bascule plein écran en largeur mobile (chantier
 * store-locator-revendeurs, point 6, section « Rendu visuel », scénario 37).
 * Remplace `ListMapSwitch.js` (ancienne bascule Liste/Carte en bas d'écran) :
 * la liste est désormais toujours visible sur mobile (elle ne dépend plus
 * d'un choix de l'écran), un aperçu de carte compact `.mobile-map-peek`
 * précède la liste, avec un bouton pour l'ouvrir en plein écran.
 *
 * Ne recrée jamais l'instance Mapbox : `.map-pane` passe simplement en
 * position fixe par CSS (`.map-pane.is-fullscreen`, ≤ 860px uniquement,
 * aucun effet au-dessus de ce seuil où la carte est déjà visible en continu).
 * `MapboxMap.js` est prévenu par l'évènement `store-locator-map-fullscreen`
 * pour appeler `map.resize()` (WebGL, nécessaire après un changement de
 * taille du conteneur).
 */
export default class MobileMapPeek extends Base {
  static config = {
    name: 'MobileMapPeek',
    refs: ['expand', 'close'],
  };

  mounted() {
    this.mapPane = this.$el.querySelector('.map-pane');
  }

  /** « Voir la carte en plein écran ». */
  onExpandClick() {
    this.setFullscreen(true);
  }

  /** « Fermer » (barre du haut de la carte plein écran). */
  onCloseClick() {
    this.setFullscreen(false);
  }

  /**
   * @param {boolean} open
   */
  setFullscreen(open) {
    this.mapPane?.classList.toggle('is-fullscreen', open);
    document.body.classList.toggle('store-locator-map-open', open);
    window.dispatchEvent(new CustomEvent('store-locator-map-fullscreen', { detail: { open } }));
  }
}
